import React from 'react';

const testIds = {
    LOCK_ICON: 'LOCK_ICON'
};

const LockIcon = (props: any) => (
    <svg
        data-test-id={testIds.LOCK_ICON}
        {...props}
        viewBox="0 0 24 24"
        width={18}
        height={18}
    >
        <path
            clipRule="evenodd"
            d="m17 7v2h2v12h-14v-12h2v-2c0-2.76142 2.23858-5 5-5 2.7614 0 5 2.23858 5 5zm-5-3c-1.6569 0-3 1.34315-3 3v2h6v-2c0-1.65685-1.3431-3-3-3zm5 15h-10v-8h10zm-6-5h2v2h-2z"
            fillRule="evenodd"
        />
    </svg>
);

export {LockIcon};
